import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { FaPlus, FaCashRegister } from 'react-icons/fa';
import api from '../../api/apiweb-cierrecaja.js';

const __DEV__ = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

const BotonGenerarCierre = ({ device_id, showLoadingModal, closeLoadingModal, setMessageLoadModal }) => {
  const [generating, setGenerating] = useState(false);

  const generarCierreNuevo = () => {
    setGenerating(true);
    showLoadingModal();
    api.nuevoCierreCaja({ device_id }).then(
      (data) => {
        if (__DEV__) { console.log(data); }
        setGenerating(false);
        closeLoadingModal();
      },
    ).catch(() => {
      setGenerating(false);
      setMessageLoadModal();
    });
  };

  return (
    <Button variant="primary" size="sm" onClick={generarCierreNuevo} disabled={generating}>
      {generating ? (
        <><Spinner animation="border" size="sm" className="me-2" />Generando…</>
      ) : (
        <><FaPlus className="me-2" />Generar</>
      )}
    </Button>
  );
};

const CierreCajaNuevo = (props) => (
  <Modal size="lg" show={props.show} onHide={props.onHide} animation={false} centered>
    <Modal.Header closeButton>
      <Modal.Title>
        <FaCashRegister className="me-2 text-primary" />
        Nuevo Cierre de Caja
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-0">
      {props.devices && props.devices.length > 0 ? (
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Local</th>
                <th>Cajero</th>
                <th className="text-end">Acción</th>
              </tr>
            </thead>
            <tbody>
              {props.devices.map((e) => (
                <tr key={e.device_id}>
                  <td>{e.local}</td>
                  <td>{e.name}</td>
                  <td className="text-end">
                    <BotonGenerarCierre
                      device_id={e.device_id}
                      showLoadingModal={props.showLoadingModal}
                      closeLoadingModal={props.closeLoadingModal}
                      setMessageLoadModal={props.setMessageLoadModal}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-state empty-state-sm">
          <FaCashRegister className="empty-state-icon" />
          <p className="empty-state-text">No hay cajeros disponibles</p>
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={props.onHide}>Cerrar</Button>
    </Modal.Footer>
  </Modal>
);

export default CierreCajaNuevo;
